module.exports = __webpack_public_path__ + "img/codeclutch.3c8de79b.png";